
import styled from 'styled-components'

import MEDIA from 'constants/media'
import COLORS from 'constants/colors'
import FONTS from 'constants/fonts'


const PhoneNumber = styled.div`
  color: ${COLORS.BLUE};
  font-size: 36px;
  font-weight: ${FONTS.WEIGHTDEMI};
  text-align: center;
  margin-top: 20px;
  ${MEDIA.medium`
    font-size: 48px;
  `}
`

export default PhoneNumber
